import faIR from 'antd/locale/fa_IR'
import _ from "lodash";

const content = {
    App: {
        title: "سفر سی",
        description: "سامانه حمل و نقل بین شهری مسافر",
    },
    Components: {
        Safar30: {
            why: "چرا سفرسی؟",
            paragraphOne: "مجموعه بزرگ سفر سی دارای اولین مجوز رسمی از سازمان راهداری و حمل ‌و نقل جاده‌ای کشور و متشکل از رانندگان و خودروهای تائید شده توسط سازمان مذکور جهت حمل و نقل بین شهری مسافر می باشد. رانندگان این شرکت علاوه بر مدارک عمومی از قبیل گواهینامه رانندگی متناسب با خودرو، بیمه نامه شخص ثالث و کارت معاینه فنی خودرو، دارای مدارک دیگری هستند که رانندگان سفر سی را متمایز می نماید.",
            paragraphTwo: "دفترچه کار راننده، برگ فعالیت راننده است که به استناد ماده 6 قانون اصلاح قانون الزام، توسط سازمان راهداری و حمل و نقل جاده ای صادر می گردد و تخلف های موضوع قانون الزام توسط پلیس راه در آن درج می گردد. در واقع رانندگان جهت تردد در جاده های کشور باید طی دورهای آموزشی که توسط پلیس راه ارائه می شود شرکت کنند تا دفتر چه کار دریافت نمایند.",
            paragraphThree: "کارت شناسائی هوشمند رانندگان که عکس دار می باشد، توسط سازمان راهداری و حمل و نقل جاده ای بمنظور تسهیل در امر حمل و نقل و شناسائی رانندگان بین شهری و کنترل رانندگان در حین تردد از مبداء تا مقصد صادر می گردد.",
            paragraphFour: "همه رانندگان دارای کارت سلامت هستند که از طریق مراجع مرتبط (وزارت بهداشت و درمان) طی آزمایشاتی دریافت می نمایند که بطور سالانه تمدید می گردد.",
        },
        Request: {
            request: "درخواست سفر",
            information: "درصورتی که متناسب با انتخاب شما سفری پیدا نشد، می توانید از قسمت زیر درخواست سفر خود را ثبت نمایید تا در کمترین زمان ممکن سفر شما را ایجاد کرده و اطلاعات سفر را به همراه لینک پرداخت برای شما پیامک نماییم.",
            origin: "مبدا",
            destination: "مقصد",
            date: "تاریخ حرکت",
            time: "ساعت حرکت",
            car: "نوع اتومبیل",
            travelType: "نوع سرویس",
            send: "ثبت درخواست",
        },
        Filter: {
            filter: "انتخاب سفر",
            origin: "مبدا",
            destination: "مقصد",
            date: "تاریخ حرکت",
            owner: "شرکت حمل مسافر",
            car: "نوع اتومبیل",
            capacity: "تعداد صندلی باقی مانده",
            reset: "بدون جستجو",
            search: "جستجو کن",
        },
        SignIn: {
            signIn: "ورود",
            mobile: "تلفن همراه",
            oneTimeCode: "کد یک بارمصرف",
            receiveCode: "دریافت کد",
        },
        Profile: {
            firstName: "نام",
            firstNameDescription: "نام باید به حروف فارسی باشد. (مثال: علی)",
            lastName: "نام خانوادگی",
            lastNameDescription: "نام خانوادگی باید به حروف فارسی باشد. (مثال: محمدی)",
            nationalCode: "کد ملی",
            nationalCodeDescription: "کد ملی باید 10 رقم باشد. (مثال: 0084526323)",
            mobile: "تلفن همراه",
            edit: "ثبت",
        },
        Menu: {
            menu: "گزینه ها",
            newTravel: "سفر جدید",
            oldTravel: "سفرهای من",
            signIn: "ورود",
            profile: "اطلاعات کاربری",
            signOut: "خروج",
            support: "تماس با ما",
            why: "چرا سفرسی؟",
        },
        Travel: {
            booking: "خرید",
            ticket: "بلیط",
            direction: "مسیر",
            origin: "مبدا",
            destination: "مقصد",
            date: "تاریخ حرکت",
            car: "اتومبیل",
            seat: "تعداد صندلی",
            toman: "تومان",
            duration: "مدت زمان سفر",
            next: "بعدی",
            prev: "قبلی",
            emptyNew: "متاسفانه متناسب با انتخاب شما سفری پیدا نشد.",
            emptyMy: "شما فاقد بلیط صادر شده می باشید.",
            filter: "انتخاب دوباره سفر",
            request: "درخواست سفر",
            travelTypeDescriptionOne: "از",
            travelTypeDescriptionTwo: "به",
            travelTypeDescriptionThree: "ترمینال",
            travelTypeDescriptionFour: "درب منزل",
        },
        Booking: {
            payment: 'پرداخت',
            capacity: "صندلی باقی مانده",
            code: "کد سفر",
            name: "نام مسافر",
            origin: "مبدا",
            destination: "مقصد",
            date: "تاریخ حرکت",
            time: "ساعت حرکت",
            address: "محل حرکت",
            car: "اتومبیل",
            seat: "تعداد صندلی اتومبیل",
            company: "شرکت حمل مسافر",
            tel: "شماره تماس شرکت",
            price: "مبلغ قابل پرداخت",
            toman: "تومان",
            Policy: {
                title: "قوانین و مقررات سفر را می پذیرم.",
                one: "سرویس نفری به سرویسی اطلاق می شود که از یک مبدا معین با محدوده مشخص شده در نقشه تعدادی مسافر را به یک مقصد با محدوده مشخص شده در نقشه منتقل می نماید.",
                two: "سرویس دربستی به سرویسی اطلاق می شود که از یک مبدا معین با محدوده مشخص شده در نقشه حداقل یک مسافر را به یک مقصد با محدوده مشخص شده در نقشه منتقل می نماید.",
                three: "سرویس درب منزل به سرویسی اطلاق می شود که از مبدا مورد انتخاب مسافر در محدوده مشخص شده نقشه حداقل یک مسافر را به یک مقصد با محدوده مشخص شده در نقشه منتقل می نماید.",
                four: "بلیط های سرویس درب منزل باید حداقل 4 ساعت قبل از زمان حرکت سرویس خریداری شده باشند.",
                five: "شرایط استرداد و کنسلی بلیط هایی که بیش از یک ساعت به زمان حرکت سرویس آنها باقی مانده است، شامل 50 درصد هزینه کنسلی و بلیط هایی که کمتر از یک ساعت به زمان حرکت سرویس آنها باقی مانده و یا سپری شده است، شامل 100 درصد هزینه کنسلی می باشند.",
                six: "حداکثر زمان برای کنسلی و لغو بلیط یک ساعت قبل از تاریخ حرکت می باشد. بلیط هایی قابل استرداد هستند که استفاده نشده باشند.",
            },
        },
        Ticket: {
            number: "شماره بلیط",
            code: "کد سفر",
            name: "نام مسافر",
            mobile: "تلفن همراه مسافر",
            nationalCode: "کد ملی مسافر",
            travelType: "نوع سرویس",
            origin: "مبدا",
            destination: "مقصد",
            date: "تاریخ حرکت",
            time: "ساعت حرکت",
            address: "محل حرکت",
            car: "اتومبیل",
            seat: "تعداد صندلی رزرو",
            company: "شرکت حمل مسافر",
            tel: "شماره تماس شرکت",
            price: "مبلغ پرداخت شده",
            toman: "تومان",
            download: "دریافت بلیط",
            cancel: "لغو بلیط",
            cancelConfirm: "آیا از لغو بلیط خود اطمینان دارید؟",
            cancelYes: "بله اطمینان دارم",
            cancelNo: "خیر",
        },
        Payment: {
            successTitle: "پرداخت موفق",
            successDescription: "پرداخت شما با موفقیت انجام گردید، هم اکنون می توانید بلیط سفر خود را مشاهده و دریافت نمایید.",
            ticket: "مشاهده و دریافت بلیط",
            errorTitle: "پرداخت ناموفق",
            errorDescription: "متاسفانه خطایی در پرداخت شما رخ داده است، در صورت کسر مبلغ از حساب شما، مبلغ واریزی عودت داده خواهد شد.",
            warningTitle: "درخواست ناموفق",
            warningDescription: "متاسفانه لینک پرداختی بلیط شما معنبر نمی باشد.",
            home: "سفر جدید",
        },
        Support: {
            company: 'سفر سی - سامانه حمل و نقل بین شهری مسافر',
            tel: '91693530',
            time: 'پاسخگویی همه روزه و 24 ساعته',
            email: 'info@safar30.ir',
            address: 'تهران، سه راه تهرانپارس، ترمینال شرق، پلاک 58',
            zipCode: '1745995115',
            contactUS: 'تماس با ما'
        },
        PendingRequest: {
            loading: "در حال دریافت اطلاعات از سرور",
        }
    },
    Validation: {
        required: "یک گزینه اجباری می باشد.",
        length: "کاراکتر باید باشد.",
        pattern: "با الگو مطابقت ندارد.",
        persian: "لطفا فقط از حروف فارسی استفاده نمایید.",
        min: "حداقل",
        max: "حداکثر",
        equalOriginDestination: "مبدا مقصد نمی توانند یکی باشند.",
    },
    Message: {
        VERIFY_CODE_INVALID: "کد یک بارمصرف مورد تایید نمی باشد.",
        VERIFY_CODE_SENT: "کد یک بارمصرف ارسال گردید.",
        VERIFY_CODE_EXIST: "کد یک بارمصرف ارسال گردیده است.",
        SIGN_IN_PROFILE: "شما وارد حساب کاربریتان شدید.",
        SIGN_OUT_PROFILE: "شما از حساب کاربریتان خارج شدید.",
        UPDATE_PROFILE: "اطلاعات حساب کاربریتان با موفقیت ویرایش شد.",
        ERROR_SEARCH: "عملیات جستجو با خطا مواجه شد.",
        ERROR_REQUEST: "متاسفانه درخواست شما با خطا مواجه شد.",
        CREATE_REQUEST: "درخواست سفر شما با موفقیت ثبت گردید.",
        BOOKING_PRICE_ZERO: "مبلغ رزرو نامعتبر می باشد.",
        BOOKING_DATE_INVALID: "تاریخ رزرو نامعتبر می باشد.",
        BOOKING_INVALID: "امکان رزرو این سفر برای شما وجود ندارد، لطفا سفر دیگری را انتخاب نمایید.",
        PAYMENT_INVALID: "امکان اتصال به درگاه بانکی وجود ندارد، لطفا مجددا تلاش نمایید.",
        TICKET_CANCEL: "بلیط شما با موفقیت لغو گردید.",
        BOOKING_CANCEL_DATE_INVALID: "بلیط هایی قابل لغو هستند که بیش از یک ساعت به حرکت آنها مانده باشد.",
        "ThrottlerException: Too Many Requests": "تعداد درخواست های شما بیش از حد مجاز است.",
        "duplicate name province": "نام استان تکراری است.",
        "duplicate name car": "نام اتومبیل تکراری است.",
        "duplicate national code user": "چنین کد ملی وجود دارد.",
    },
    Enum: {
        Form: {
            FILTER: "انتخاب سفر",
            SIGN_IN: "ورود به سامانه جهت خرید بلیط اینترنتی",
            BOOKING: "خرید بلیط اینترنتی",
            PROFILE: "اطلاعات کاربری",
            SUPPORT: "تماس با ما",
            TICKET: "بلیط اینترنتی",
            PAYMENT: "گزارش پرداخت",
            SAFAR30: "چرا سفر سی ؟",
            REQUEST: "درخواست سفر",
        },
        Capacity: {
            ONE: "1 صندلی",
            TWO: "2 صندلی",
            THREE: "3 صندلی",
        },
        Bank: {
            SAMAN: "بانک سامان",
            MEHR_IRAN: "بانک قرض‌الحسنه مهر ایران",
            REFAH: "بانک رفاه کارگران",
            SADERAT: "بانک صادرات ایران",
            TOSE_TAAVON: "بانک توسعه تعاون",
            KHAVAREMIYANEH: "بانک خاورمیانه",
            POST_BANK: "پست بانک ایران",
            GARDESHGARI: "بانک گردشگری",
            SINA: "بانک سینا",
            SEPAH: "بانک سپه",
            TEJARAT: "بانک تجارت",
        },
        Payment: {
            SEP: "پرداخت الکترونیک سامان کیش",
            PEP: "پرداخت الکترونیک پاسارگاد",
            ZARINPAL: "پرداخت یاری زرین پال",
            CASH: "پرداخت نقدی",
            CREDIT: "پرداخت اعتباری",
        },
        TravelType: {
            PERSON: "سرویس نفری",
            CLOSE: "سرویس دربستی",
            HOME: "سرویس درب منزل",
        },
    },
    Share: {
        safar30: "سفر سی (سامانه حمل و نقل بین شهری مسافر)",
        rmto: "سازمان راهداری و حمل و نقل بین جاده ای",
        enamad: "نماد اعتماد الکترونیک",
        pep: "شرکت پرداخت الکترونیک پاسارگاد",
        sep: "شرکت پرداخت الکترونیک سامان کیش",
        zarinpal: "شرکت پرداخت یاری زرین پال",
        tour: "با کلیک بر روی دکمه انتخاب سفر مبدا، مقصد و زمان حرکت سفر تو انتخاب و بلیط تو خرید کن!",
        optional: "انتخاب این گزینه اختیاری می باشد.",
    },
    Tour: {
        Finish: 'متوجه شدم'
    },
    DatePicker: {
      lang: {
          ok: 'تایید'
      }
    },
    Dayjs: {
        monthsShort: [
            'فروردین',
            'اردیبهشت',
            'خرداد',
            'تیر',
            'مرداد',
            'شهریور',
            'مهر',
            'آبان',
            'آذر',
            'دی',
            'بهمن',
            'اسفند'
        ]
    },
}

export default _.merge(faIR, content);
